﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import { hasPermission, toast } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_element } from "../hauliers.constants";
import { useHaulier } from "@/hooks/maintainers/hauliers";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import { customStyles } from "@/components/ReactSelect/NoOptions.styles";

const HauliersForm = ({ confirmSave, isLoadingSave, estates_parents, estates, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [data, setData] = useState({ ...base_element });

	const { data: response, isLoading } = useHaulier(slug);

	useEffect(() => {
		if (response) {
			setData(response.detail);
		} else {
			let baseElement = { ...base_element };

			if (estates_parents && estates_parents.length === 1) {
				baseElement.estates_parents = [estates_parents[0].value];
			}
			if (estates && estates.length === 1) {
				baseElement.estates = [estates[0].value];
			}

			setData(baseElement);
		}

		// eslint-disable-next-line
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/configuracion/transportistas");
	};

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Transportista</h4>
			</Modal.Header>

			<Modal.Body>
				{isLoading || isLoadingSave ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>
								<Form.Control
									value={data ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Campo</Form.Label>
								<Select
									isMulti
									value={estates_parents && estates_parents.filter((ep) => data.estates_parents && data.estates_parents.includes(ep.value))}
									placeholder={<div>Seleccione Campo</div>}
									options={estates_parents ? estates_parents : []}
									onChange={(value) => {
										let newEstatesParents = [];
										value &&
											value.map((estate_parent) => {
												newEstatesParents.push(estate_parent.value);
												return null;
											});

										let availableEstates = estates.filter((e) => newEstatesParents.includes(e.estate_parent_id));

										setData({
											...data,
											estates_parents: newEstatesParents,
											estates: availableEstates.map((e) => e.value),
										});
									}}
									components={{
										NoOptionsMessage,
									}}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Bodega</Form.Label>
								<Select
									isMulti
									value={estates && estates.filter((et) => data.estates && data.estates.includes(et.value))}
									placeholder={<div>Seleccione Bodega</div>}
									options={estates ? estates.filter((e) => data.estates_parents.includes(e.estate_parent_id)) : []}
									onChange={(value) => {
										let newEstates = [];
										value &&
											value.map((estate) => {
												newEstates.push(estate.value);
												return null;
											});

										setData({
											...data,
											estates: newEstates,
										});
									}}
									components={{
										NoOptionsMessage,
									}}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isLoading && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || (isLoadingSave && true)}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default HauliersForm;
